module.exports = __webpack_public_path__ + "img/orange_mark.e6f87b7f.svg";